import { ICategoryDto } from "./CategoryDto";

export interface IProductDto {
    amount: string | null;
    categories: ICategoryDto[] | null;
    descr: string | null;
    image: string | null;
    imageType: string | null;
    name: string | null;
    productId: string | null;
    imageName: string | null;
    lastUpdate: string | null;
}

export class ProductDto implements IProductDto {
    public amount: string | null;
    public categories: ICategoryDto[] | null;
    public descr: string | null;
    public image: string | null;
    public imageType: string | null;
    public name: string | null;
    public productId: string | null;
    public imageName: string | null;
    public lastUpdate: string | null;

    constructor(amount: string | null, categories: ICategoryDto[] | null, desc: string | null, image: string | null, imageType: string | null, 
            name: string | null, productId: string | null, imageName: string | null, lastUpdate: string | null) {
        this.amount = amount;
        this.categories = categories;
        this.descr = desc;
        this.image = image;
        this.imageType = imageType;
        this.name = name;
        this.productId = productId;
        this.imageName = imageName;
        this.lastUpdate = lastUpdate;
    }
}